import type { PendingInteraction, RuntimeMessage, SessionState } from "./types";

const publicEntryPointPattern = /^[A-Za-z0-9][A-Za-z0-9_-]{2,127}$/;

export function publicEntryPointId(pathname: string): string | undefined {
  if (pathname === "/") return "entry_dogfood";
  const match = pathname.match(/^\/e\/([^/]+)$/);
  return match && publicEntryPointPattern.test(match[1]) ? match[1] : undefined;
}

export function canResumeEntry(pathname: string, requestedEntryPointId: string | undefined, sessionEntryPointId: string | undefined): boolean {
  if (sessionEntryPointId) return sessionEntryPointId === requestedEntryPointId;
  return pathname === "/";
}

export function correlationId(): string {
  return `correlation-${crypto.randomUUID()}`;
}

export function interaction(state: SessionState, value: unknown, componentId?: string): PendingInteraction {
  if (!state.interface) throw new Error("No active interface");
  return {
    type: "interaction.submit",
    protocolVersion: 1,
    correlationId: correlationId(),
    idempotencyKey: crypto.randomUUID(),
    expectedRevision: state.revision,
    interfaceId: state.interface.id,
    componentId: componentId || state.interface.component.id,
    value,
  };
}

export function applyMessage(current: SessionState, message: RuntimeMessage): SessionState {
  if (message.protocolVersion !== 1) throw new Error("Unsupported protocol");
  if (["session.accepted", "interface.replace", "interaction.committed"].includes(message.type)) {
    if (typeof message.revision !== "number") throw new Error("Missing revision");
    if (message.revision < current.revision) return current;
    return { ...current, revision: message.revision, screenIndex: message.screenIndex ?? current.screenIndex, screenCount: message.screenCount ?? current.screenCount, segmentId: message.segmentId ?? current.segmentId, canGoBack: message.canGoBack ?? current.canGoBack, answers: message.answers ?? current.answers, interface: message.interface, status: "active" };
  }
  if (message.type === "session.completed") {
    if (typeof message.revision !== "number" || !message.result) throw new Error("Incomplete result");
    if (message.revision < current.revision) return current;
    return { ...current, revision: message.revision, interface: undefined, status: "resolved", result: message.result };
  }
  return current;
}
